import axios from 'axios'

export class BaseService {

  constructor() { }

  async get(resource = '', withAuthorization = false) {
    return axios.get(`${process.env.REACT_APP_API_URL}${resource}`, this.getConfig(withAuthorization)).then(res => res.data);
  }

  async post(resource = '', data = {}, withAuthorization = false) {
    return axios.post(`${process.env.REACT_APP_API_URL}${resource}`, data, this.getConfig(withAuthorization)).then(res => res.data);
  }

  async patch(resource = '', data = {}, withAuthorization = false) {
    return axios.patch(`${process.env.REACT_APP_API_URL}${resource}`, data, this.getConfig(withAuthorization)).then(res => res.data);
  }

  async delete(resource = '', withAuthorization = false) {
    return axios.delete(`${process.env.REACT_APP_API_URL}${resource}`, this.getConfig(withAuthorization)).then(res => res.data);
  }

  getConfig(withAuthorization = false) {
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);
    return {
      headers: {
        'X-Client-Id': process.env.REACT_APP_API_X_CLIENT_ID,
        ...(withAuthorization && token && { 'Authorization': `Bearer ${token}` }),
      }
    }
  }
  
}